import { useMutation, useQueryClient } from "@tanstack/react-query";
import { jwtDecode } from "jwt-decode";

import { useAuth } from "@contexts/auth";
import { api } from "@utils/api";
import { onboardingQKeys } from "@hooks/queries/onboarding/queryKeys";

export const useFinalizeOnboarding = () => {
  const queryClient = useQueryClient();
  const { setToken, setOnboardingStatus } = useAuth();

  return useMutation({
    mutationFn: () => api.post("onboarding/session/me/finalize"),
    onSuccess: ({ data }) => {
      const decoded: { onboarding_status?: string } = jwtDecode(data.access_token);
      setToken(data.access_token);
      setOnboardingStatus(decoded.onboarding_status || data.session.status);
      queryClient.setQueryData(onboardingQKeys.session(), { data: data.session });
    },
  });
};
